export type NewSpacing = {
  xsmall: React.CSSProperties['padding'];
  small: React.CSSProperties['padding'];
  medium: React.CSSProperties['padding'];
  large: React.CSSProperties['padding'];
  xl: React.CSSProperties['padding'];
};

export const NEW_SPACING: NewSpacing = {
  xsmall: '0.25rem',
  small: '0.5rem',
  medium: '1rem',
  large: '1.5rem',
  xl: '2rem',
};

export type NewShapes = {
  borderRadius: {
    small: React.CSSProperties['borderRadius'];
    medium: React.CSSProperties['borderRadius'];
  };
};

export const NEW_SHAPES: NewShapes = {
  borderRadius: {
    small: '0.5rem',
    medium: '0.75rem',
  },
};
